import type { OrderStatus } from '~domains/orders/entities/order';

import type { StatusTone } from '~shared/ui/status-badge';
import { StatusBadge } from '~shared/ui/status-badge';

import { ORDER_STATUS_LABELS } from '../lib/order-status';

const statusTone: Record<OrderStatus, StatusTone> = {
  NEW: 'warning',
  IN_PROGRESS: 'info',
  APPROVED: 'positive',
  REJECTED: 'negative',
  CANCELLED: 'neutral',
  FINISHED: 'positive',
};

type Props = {
  status: OrderStatus;
};

export const OrderStatusBadge = ({ status }: Props) => {
  const tone = (statusTone[status] as StatusTone | undefined) ?? 'neutral';
  const label = (ORDER_STATUS_LABELS[status] as string | undefined) ?? status;

  return <StatusBadge tone={tone}>{label}</StatusBadge>;
};
